import axios from 'axios';
import { API_AUTH_URL } from '../config/api';

const API_URL = API_AUTH_URL + '/';

const storeSession = (data) => {
  if (data?.access_token) {
    localStorage.setItem('user', JSON.stringify(data));
    localStorage.setItem('token', data.access_token);
  }
  return data;
};

const register = (email, password) => {
  return axios.post(API_URL + 'register', {
    email,
    password,
  });
};

const login  = (email, password) => {
  return axios.post(API_URL + 'login', {
    email,
    password
  })
  .then(response => storeSession(response.data));
};

const googleLogin = (credential, context = {}) => axios.post(API_URL + 'google', {
  credential,
  ...context,
}).then(response => storeSession(response.data));

const requestPasswordReset = (email) => {
  return axios.post(API_URL + 'forgot-password', { email });
};

const resetPassword = (payload) => {
  return axios.post(API_URL + 'reset-password', payload);
};

const logout = async () => {
  try {
    const token = localStorage.getItem('token');
    if (token) {
      await axios.post(API_URL + 'logout', {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
    }
  } catch (_) {
    // ignora erros ao fazer logout no servidor
  } finally {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  }
};

const refreshToken = async () => {
  const token = localStorage.getItem('token');
  if (!token) return null;
  try {
    const response = await axios.post(API_URL + 'refresh', {}, {
      headers: { Authorization: `Bearer ${token}` }
    });
    const newToken = response.data.access_token;
    localStorage.setItem('token', newToken);
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (user) {
      user.access_token = newToken;
      localStorage.setItem('user', JSON.stringify(user));
    }
    return newToken;
  } catch (_) {
    return null;
  }
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem('user'));
};

const updateStoredUser = (userData) => {
  const session = getCurrentUser();
  if (!session || !userData) return session;

  const updatedSession = session.user
    ? { ...session, user: { ...session.user, ...userData } }
    : { ...session, ...userData };

  localStorage.setItem('user', JSON.stringify(updatedSession));
  window.dispatchEvent(new Event('authChanged'));
  return updatedSession;
};

const isEnrolled = async (cursoId) => {
  const user = getCurrentUser();
  if (user && user.access_token) {
    const response = await axios.get(`${API_URL}meus-cursos`, {
      headers: {
        'Authorization': `Bearer ${user.access_token}`
      }
    });
    const enrolledCourses = response.data;
    return enrolledCourses.some(course => course.id === cursoId);
  }
  return false;
};

export default {
  register,
  login,
  googleLogin,
  requestPasswordReset,
  resetPassword,
  logout,
  getCurrentUser,
  updateStoredUser,
  isEnrolled,
  refreshToken,
};
